<template>
  <div class="cover">
    <div class="title">封面</div>
    <div class="preview" ref="preview">
      <!-- <img :src="$handleAssetsUrl(activeItem.img)" alt /> -->
      <img class="preview-cover" :src="blobToUrl(activeItem)" alt />
      <div class="watermark-show" v-if="watermarkType === 'default'">
        <img
          src="https://resources.laihua.com/watermark/video-watermark.png"
          :style="watermarkStyle"
          @load="updateWatermarkStyle()"
          alt
        />
      </div>
      <drr
        v-if="watermarkType === 'custom'"
        v-bind="getMovingHandler()"
        ref="drrHorizontal"
        @change="sendInfoToEngine"
        @dragstop="onDragStop"
        @resizestop="onResizeStop"
        @rotatestop="onResizeStop"
        @select="onDrrActive"
      >
        <div class="watermark-custom">
          <img
            :src="$handleAssetsUrl(customWatermarkUrl)"
            alt
            @mousedown.prevent
            @load="drrImgLoad($event)"
          />
        </div>
      </drr>
      <div
        class="swap-cover"
        v-show="activeIndex === 3"
        @click="swapCustomCover"
      >
        替换
      </div>
    </div>
    <div class="text-row">
      <div>请选择封面，并设置是否合成至视频第一帧：</div>
      <div class="cover-option" @click="onClickCoverOption">
        <el-switch
          v-model="isFirstFrameCover_"
          :disabled="UserLevel === 0"
        ></el-switch>
        <div
          v-if="UserLevel === 0"
          style="width: 30px; position: absolute; right: -12px; top: -6px"
        >
          <vipBadge></vipBadge>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="picker">
        <div
          v-for="(item, i) in items"
          class="item"
          :class="{ active: activeIndex === i }"
          @click="pick(i)"
        >
          <!-- <img :src="$handleAssetsUrl(item.img)" alt /> -->
          <img :src="blobToUrl(item)" alt />
        </div>
      </div>
      <!-- :for="UserEquity.noCustomCover ? 'none' : worksCover" -->
      <!-- id="worksCover" -->
      <div
        @click="addCustomCover"
        class="upload-btn"
        v-show="items.length <= 3"
        ref="inputTrigger"
        :style="{
          cursor: UserEquity.noCustomCover ? 'not-allowed' : 'pointer',
        }"
      >
        <input
          type="file"
          name="worksCover"
          accept="image/png, image/jpeg, image/jpg"
          @change="inputChange($event)"
          ref="fileInputRef"
        />
        <div
          v-if="UserEquity.noCustomCover"
          class="mark"
          style="width: 30px; position: absolute; right: -12px; top: -6px"
        >
          <vipBadge></vipBadge>
        </div>
      </div>
    </div>
    <div class="tip-row">（如果需要上传封面，建议大小不超过500K）</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import drr from "@/plugins/drr";
import vipBadge from "@/components/widgets/vipBadge.vue";

const PREVIEW_WIDTH = 493;
const PREVIEW_HEIGHT = 277.3;

export default {
  components: {
    drr,
    vipBadge,
  },
  model: {
    prop: "value",
    event: "selectCover",
  },
  props: {
    value: [String, Blob],
    isFirstFrameCover: Boolean,
  },
  data() {
    return {
      watermarkState: "show", // show | hide | custom
      activeIndex: 0,
      items: [],
      watermarkStyle: {},
    };
  },
  computed: {
    ...mapGetters(["UserLevel", "UserEquity"]),
    ...mapGetters({
      watermarkType: "subtitleExport/watermarkType",
      customWatermarkUrl: "subtitleExport/customWatermarkUrl",
      subtitleObj: "subtitle/subtitleObj",
      customCover: "subtitleExport/customCover",
      isShowCoverDialog: "subtitleExport/isShowCoverDialog",
    }),
    activeItem() {
      if (this.items && this.items.length > 0) {
        return this.items[this.activeIndex];
      } else {
        return null;
      }
    },
    isFirstFrameCover_: {
      get() {
        return this.isFirstFrameCover;
      },
      set() {
        this.toggleFirstFrameCover();
      },
    },
  },
  watch: {
    watermarkType(val) {},
    customCover(val) {
      this.items = [...this.items.slice(0, 3), val];
    },
    isShowCoverDialog(val) {
      if (this.items.length === 4) {
        this.activeIndex = 3;
      }
    },
  },
  methods: {
    pick(index) {
      this.activeIndex = index;
      this.$emit("selectCover", this.items[index]);
    },
    inputChange() {
      let { files } = this.$refs.fileInputRef;
      if (files[0].size > 10 * 1024 * 1024) {
        this.$message({
          type: "error",
          message: "选中图片已经超出10MB限制",
        });
        this.$refs.fileInputRef.value = "";
        return;
      }
      let customCover = window.URL.createObjectURL(files[0]);
      this.$store.commit("subtitleExport/setCustomCover", files[0]);
      this.$store.commit("subtitleExport/showCoverDialog", true);
      this.$refs.fileInputRef.value = "";
    },

    getMovingHandler(dire) {
      if (
        this.subtitleObj.watermarkInfo &&
        this.subtitleObj.watermarkInfo.url
      ) {
        return this.getMovingHandlerByInfo();
      }
      let obj = this.getWatermarkStyle({
        markWidth: PREVIEW_WIDTH / 5,
        markHeight: PREVIEW_WIDTH / 12,
      });

      // this.watermarkInfo.defaults.w = w;
      // this.watermarkInfo.defaults.h = h;

      return {
        x: obj.left + obj.width / 2,
        y: obj.top + obj.height / 2,
        w: obj.width,
        h: obj.height,
        aspectRatio: true,
        // selected: true,
        angle: 0,
        alwaysActive: false,
        isLimit: true,
        innerBound: {
          w: 12,
          h: 12,
        },
      };
    },

    getMovingHandlerByInfo() {
      let resolution = this.checkedPixel.value;
      let videoH = resolution;
      let ratio = PREVIEW_HEIGHT / videoH;
      let info = this.subtitleObj.watermarkInfo;
      let x = info.x * ratio;
      let y = info.y * ratio;
      let w = info.w * ratio;
      let h = info.h * ratio;
      return {
        x,
        y,
        w,
        h,
        aspectRatio: true,
        // selected: true,
        angle: info.angle,
        alwaysActive: false,
        isLimit: true,
        innerBound: {
          w: 12,
          h: 12,
        },
      };
    },

    getWatermarkPosition(resolution) {
      resolution = parseInt(resolution);
      let drr = this.$refs.drrHorizontal || {};
      let videoH = resolution;
      if (this.subtitleObj.optimized === "Vertical") {
        drr = this.$refs.drrVertical || {};
        videoH = (resolution * 16) / 9;
      }
      // previewH / videoH = drr.rect.x / output.x
      let ratio = PREVIEW_HEIGHT / videoH;
      let names = ["x", "y", "w", "h"];
      let keys = Object.keys(drr.rect);
      let output = {
        resolution,
      };
      keys.forEach((k) => {
        let v = drr.rect[k];
        if (names.indexOf(k) > -1) {
          output[k] = v / ratio;
        } else {
          output[k] = v;
        }
      });
      // console.log({positionBefore: drr.rect, positionAfter: output})

      return output;
    },

    updateMovingHandler({ w, h } = {}) {
      let drr = this.$refs.drrHorizontal || {};
      if (this.subtitleObj.optimized === "Vertical") {
        drr = this.$refs.drrVertical || {};
      }

      if (!w || !h) {
        return;
      }

      drr.width = w;
      drr.height = h;

      this.$nextTick(() => {
        this.saveMovingHandlerSize({
          w,
          h,
          obj: this.checkedWatermark,
        });
      });
    },
    saveMovingHandlerSize({ w, h, obj = {} } = {}) {
      obj = obj || {};
      // obj.w = w;
      // obj.h = h;
      this.$set(obj, "w", w);
      this.$set(obj, "h", h);
    },
    getDrr() {
      let drr = this.$refs.drrHorizontal || {};
      return drr;
    },

    sendInfoToEngine() {
      let watermarkPosition = this.getWatermarkPosition(
        this.subtitleObj.coordinate.height
      );
      let watermarkInfo = {
        url: this.$unhandleAssetsUrl(this.customWatermarkUrl),
        ...watermarkPosition,
      };
      this.watermarkInfo = watermarkInfo;
      this.$store.commit("subtitleExport/setCustomWatermark", watermarkInfo);
    },

    onDragStop() {
      this.$analysis("customized_watermark,drag_location,自定义水印_位置");
    },
    onResizeStop() {
      this.$analysis("customized_watermark,drag_scale，自定义水印_放缩");
    },
    onDrrActive() {
      this.sendInfoToEngine();
    },
    videoPrintScreen(url, time) {
      return new Promise(function (resolve, reject) {
        let video = document.createElement("video");
        let judgeVideo = true;
        video.setAttribute("src", url);
        video.crossOrigin = "";
        video.currentTime = time;
        video.addEventListener("canplaythrough", (event) => {
          let canvas = document.createElement("canvas");
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          canvas
            .getContext("2d")
            .drawImage(video, 0, 0, canvas.width, canvas.height);

          canvas.toBlob((blob) => {
            // dataURL = window.URL.createObjectURL(blob)
            resolve(blob);
          }, "image/png");
        });
      });
    },
    async getVideoCovers() {
      // let url =
      //   "https://resources.laihua.com/2020-7-15/1c5197c0-c664-11ea-ac0b-1fe7a9c07edb.mp4";
      // let time2 = 3;
      // let time3 = 6;
      let url =
          "https://resources.laihua.com/" +
          this.subtitleObj.url.replace("https://resources.laihua.com/", ""),
        time2 = this.subtitleObj.duration / 2,
        time3 = this.subtitleObj.duration;
      let cover1 = await this.videoPrintScreen(url, 0.1);
      let cover2 = await this.videoPrintScreen(url, time2);
      let cover3 = await this.videoPrintScreen(url, time3);
      this.items = [cover1, cover2, cover3];
      this.pick(0);
    },
    blobToUrl(b) {
      if (!b) {
        return;
      }
      return window.URL.createObjectURL(b);
    },
    swapCustomCover() {
      this.$refs.inputTrigger.click();
    },
    drrImgLoad(ev) {
      let drr = this.$refs.drrHorizontal || {};
      let el = ev.target;
      let ratio = el.naturalWidth / el.naturalHeight;
      let h = el.height;
      let w = h * ratio;

      this.updateMovingHandler({ w, h });
      let { left } = this.getWatermarkStyle({
        markWidth: w,
        markHeight: h,
      });
      drr.$nextTick(() => {
        // drr.$set(drr, "cx", previewWidth - (w * 1.2) / 2);
        drr.$set(drr, "cx", left + w / 2);
      });
    },
    toggleFirstFrameCover() {
      let flag = !this.isFirstFrameCover;
      this.$emit("toggleFirstFrameCover", flag);
    },
    getWatermarkStyle1({
      markWidth,
      markHeight,
      wrapperWidth,
      wrapperHeight,
    } = {}) {
      let coverHeight = PREVIEW_HEIGHT;
      let coverWidth =
        (coverHeight * this.subtitleObj.coordinate.width) /
        this.subtitleObj.coordinate.height;
      let gap = (wrapperWidth - coverWidth) / 2;
      let markLeft = coverWidth + gap - markWidth - coverWidth * 0.01;
      let markTop = wrapperHeight - markHeight - coverHeight * 0.01;
      return {
        position: "absolute",
        left: markLeft,
        top: markTop,
        width: markWidth,
        height: markHeight,
      };
    },
    getWatermarkStyle2({
      markWidth,
      markHeight,
      wrapperWidth,
      wrapperHeight,
    } = {}) {
      let coverWidth = PREVIEW_WIDTH;
      let coverHeight =
        coverWidth /
        (this.subtitleObj.coordinate.width /
          this.subtitleObj.coordinate.height);

      let gap = (wrapperHeight - coverHeight) / 2;
      let markLeft = coverWidth - markWidth - coverWidth * 0.01;
      let markTop = coverHeight + gap - markHeight - coverHeight * 0.01;
      return {
        position: "absolute",
        left: markLeft,
        top: markTop,
        width: markWidth,
        height: markHeight,
      };
    },
    getWatermarkStyle({ markWidth, markHeight } = {}) {
      let baseRatio = 16 / 9;
      let videoRatio =
        this.subtitleObj.coordinate.width / this.subtitleObj.coordinate.height;
      let el = this.$refs.preview;
      let $el = $(el);
      let wrapperWidth = $el.width();
      let wrapperHeight = $el.height();
      markWidth = markWidth || wrapperWidth / 5;
      markHeight = markHeight || wrapperWidth / 12;
      if (videoRatio <= baseRatio) {
        return this.getWatermarkStyle1({
          markWidth,
          markHeight,
          wrapperWidth,
          wrapperHeight,
        });
      } else {
        return this.getWatermarkStyle2({
          markWidth,
          markHeight,
          wrapperWidth,
          wrapperHeight,
        });
      }
    },
    updateWatermarkStyle() {
      let obj = this.getWatermarkStyle();
      this.watermarkStyle = {
        position: "absolute",
        left: obj.left + "px",
        top: obj.top + "px",
        width: obj.width + "px",
        height: obj.height + "px",
      };
    },
    onClickCoverOption() {
      if (this.UserLevel === 0) {
        this.$modal.show("subtitleVipDialog", {
          msg: "升级个人会员，解锁视频合成封面技能",
          target: "vipsolo",
          type: "solo",
        });
      }
    },
    addCustomCover() {
      if (this.UserEquity.noCustomCover) {
        this.$memberGuide({
          show: true,
          context: this,
          funcRight: {
            type: "selfDefineCover",
            name: "自定义视频封面",
          },
        });
        return;
      }
      this.$refs.fileInputRef.click();
    },
  },
  created() {
    this.getVideoCovers();
  },
  mounted() {
    this.updateWatermarkStyle();
  },
};
</script>

<style lang="scss" scoped>
.cover {
  position: relative;
}
.preview {
  position: relative;
  width: 493px;
  height: 277.3px;
  text-align: left;
  overflow: hidden;
  & > img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    margin: auto;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
.row {
  display: flex;
  align-items: center;
}
.picker {
  display: inline-block;
  margin-right: 20px;
}
.item {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 57px;
  margin-left: 10px;
  cursor: pointer;
  outline: 1px solid #e3c7d9;
  & > img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    margin: auto;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
  &:first-child {
    margin-left: 0;
  }

  &.active {
    outline: 2px solid #5778fb;
  }
}
.upload-btn {
  position: relative;
  display: inline-block;
  width: 70px;
  height: 50px;
  background: #ececf7;
  border: 1px solid #d8d8e5;
  border-radius: 4px;
  cursor: pointer;
  & > input {
    visibility: hidden;
  }
  &:before,
  &:after {
    content: " ";
    background-color: #5778fb;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:before {
    width: 18px;
    height: 2px;
  }
  &:after {
    width: 2px;
    height: 18px;
  }
}
.title {
  position: absolute;
  top: 16px;
  right: calc(100% + 28px);
  font-size: 14px;
  color: #474261;
  min-width: 100px;
  text-align: right;
}
.text-row {
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 20px;
  padding-left: 9px;
  font-size: 14px;
  color: #474261;
  text-align: left;
}
.tip-row {
  margin-top: 13px;
  font-size: 14px;
  color: #c2c2d9;
  text-align: left;
}
.watermark-show {
  // position: absolute;
  // right: 0;
  // bottom: 0;
  // width: 100%;
  // height: 100%;
  // background: url(../../../../static/animengine/img/icon-default-watermark-h.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 0;
  margin: auto;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  & > img {
    position: absolute;
    bottom: 8%;
    right: 8%;
  }
}
.watermark-custom {
  // position: absolute;
  // left: 357.425px;
  // top: 223.77px;
  // width: 123.25px;
  // height: 49.3px;
  width: 100%;
  height: 100%;
  & > img {
    width: 100%;
    height: 100%;
  }
}
.swap-cover {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #474261;
  border-radius: 4px;
  color: #474261;
  box-shadow: 0 0 3px 0 rgba(71, 66, 97, 0.3);
  cursor: pointer;
}
.cover-option {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleExport/cover.vue